<script>
import router from "@/router";

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  props: [
    'userType',
    'location'
  ],
  components: {  },
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
    }
  },
  methods: {
    personalInformation(userTypeId,locationId) {
      router.push({ name: 'contact-info', params: {
          userType: userTypeId,
          location :locationId
        }})
    },
    questions(userTypeId,locationId) {
      router.push({ name: 'questions', params: {
          userType: userTypeId,
          location :locationId
        }})
    },
    faith(userTypeId,locationId) {
      router.push({ name: 'faith', params: {
          userType: userTypeId,
          location :locationId
        }})
    },
    additionalDetails(userTypeId,locationId) {
      router.push({ name: 'additional-details', params: {
        userType: userTypeId,
            location :locationId
      }})
    },
    opportunities(userTypeId,locationId) {
      router.push({ name: 'opportunities', params: {
          userType: userTypeId,
          location :locationId
        }})
    },
  },
}
</script>

<template>
    <div class="card">
      <div class="card-body py-5">
        <div class="mt-1">
            <h5 class="card-title mb-5">Review Application
            </h5>
        </div>

        <div class="btns-group mt-4 mb-3">
          <b-button @click="personalInformation(userType,location)" variant="primary" class="w-sm rounded-0">
            <i class="bx bx-check d-block mb-2"></i>
            Personal Information
            <a href="javascript:;" class="rvw-link">Review</a>
          </b-button>

          <b-button @click="questions(userType,location)" variant="primary" class="w-sm rounded-0">
            <i class="bx bx-check d-block mb-2"></i>
            Questions
            <a href="javascript:;" class="rvw-link">Review</a>
          </b-button>

          <b-button @click="faith(userType,location)" variant="primary" class="w-sm rounded-0">
            <i class="bx bx-check d-block mb-2"></i>
            Faith
            <a href="javascript:;" class="rvw-link">Review</a>
          </b-button>

          <b-button @click="opportunities(userType,location)" variant="primary" class="w-sm rounded-0">
            <i class="bx bx-check d-block mb-2"></i>
            Opportunities
            <a href="javascript:;" class="rvw-link">Review</a>
          </b-button>

          <b-button @click="additionalDetails(userType,location)" variant="primary" class="w-sm rounded-0">
            <i class="bx bx-check d-block mb-2"></i>
            Additional Details
            <a href="javascript:;" class="rvw-link">Review</a>
          </b-button>
        </div>

        <div class="mt-5">
          <p class="note text-center fw-bold">
            You many submit your information for registration, please note that
            you can update your information at any time.
          </p>
      </div>

        <div class="text-center mt-3">
          <b-button variant="primary" @click="$bvModal.show('mentorApplicationComplete')" class="fw-bold w-sm py-3 px-5">
            Submit Application
          </b-button>
        </div>

      </div>

      <b-modal
          id="mentorApplicationComplete"
          centered
          size="lg"
          title="Your application has been submitted!"
          title-class="font-18"
          hide-footer
      >

        <div class="row">
          <div class="col-12">
            <article>
              <p>Thank you for completing your application to become MNTC mentor. A member of our team will be reaching
                out to you directly if you are selected or if we need additional information.</p>
            </article>

            <article class="px-5 text-center">
              <h4 class="fw-bold mb-3 mt-4 text-start">What to Expect?</h4>
              <p class="mt-2 text-start">
                We will communicate acceptance or rejection of you application
                with X Business Days
              </p>
              <p class="mt-2 text-start">
                We will be connecting with your references listed
                in the application
              </p>
              <p class="mt-2 text-start">
                All applicants will be subject to a background check
              </p>
              <p class="mt-2 text-start">
                If accepted, we will reach out to schedule orientation with the MNTC <team class=""></team>
              </p>
              <button type="button" @click="$bvModal.hide('mentorApplicationComplete')"
                      class="btn btn-primary py-2 px-4 mt-3 mb-2">
                Visit MNTC.ORG</button>
            </article>
          </div>
        </div>

      </b-modal>

    </div>
</template>
<style scoped>
.card{
  position: static;
  width: 80%;
  margin: 0 auto;
  margin-top:3rem;
}
.btns-group button{
  background-color:transparent !important;
  color:#000000;
  line-height:16px;
  border:none !important;
  width:calc(100% / 5 - 0px);
  margin-bottom:2rem;
  font-weight: bold;
}
.btns-group button:focus{
  outline:none !important;
  box-shadow:none !important;
}
.btns-group button i{
  background-color: #e3e3e7;
  width: 120px;
  height: 60px;
  line-height: 60px;
  font-size: 30px !important;
  margin: auto;
}
.btns-group .rvw-link{
  text-decoration: underline !important;
  display:block;
  font-weight: normal;
  margin-top:0.5rem;
}
</style>
